import styled from 'styled-components';

import { textSize, brand, ink, surface, tones } from '../../../../styles/brand';
export const FieldLabel = styled.span`
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(0.85)};
  color: ${tones.gray.text};
  display: block;
  margin-bottom: 0.4rem;
`;

export const FieldRow = styled.div`
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  flex-wrap: wrap;
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  position: relative;
`;

export const FieldError = styled.span`
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(0.78)};
  color: ${tones.red.text};
  position: absolute;
  right: 0;
  top: 0;
`;

export const ArenaCard = styled.div`
  border: 1px solid ${tones.blue.border};
  border-radius: 0.6rem;
  padding: 1rem;
  background: ${tones.blue.soft};
  margin-bottom: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const TagsRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

export const Tag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: #fff;
  border: 1px solid ${tones.blue.border};
  border-radius: 2rem;
  padding: 0.25rem 0.75rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(0.82)};
  color: ${ink};

  button {
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    color: ${tones.gray.text};
    font-size: ${textSize(0.9)};
    line-height: 1;
    transition: color 0.2s;

    &:hover {
      color: ${tones.red.text};
    }
  }
`;

export const DropdownButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  border: 1px solid ${surface.line};
  border-radius: 0.5rem;
  padding: 0.35rem 0.8rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(0.85)};
  background: #fff;
  cursor: pointer;
  color: ${ink};
  transition: border-color 0.2s;
  white-space: nowrap;

  &:hover {
    border-color: ${brand.orange};
  }
`;

export const DropdownWrapper = styled.div`
  position: relative;
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  background: #fff;
  border: 1px solid ${surface.line};
  border-radius: 0.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  z-index: 100;
  min-width: 200px;
  overflow: hidden;
`;

export const DropdownOption = styled.button`
  width: 100%;
  text-align: left;
  padding: 0.6rem 1rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(0.85)};
  background: #fff;
  border: none;
  cursor: pointer;
  color: ${ink};
  transition: background 0.15s;

  &:hover {
    background: rgba(255, 152, 0, 0.08);
  }
`;

export const AddArenaButton = styled.button`
  width: 100%;
  border: 1.5px dashed ${brand.blue};
  border-radius: 0.6rem;
  background: #fff;
  padding: 0.8rem;
  font-family: 'RedHatDisplay-Bold';
  font-size: ${textSize(0.95)};
  color: ${brand.blue};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  margin-top: 0.5rem;
  transition:
    background 0.2s,
    border-color 0.2s;

  &:hover {
    background: rgba(30, 136, 229, 0.04);
    border-color: ${tones.blue.text};
    color: ${tones.blue.text};
  }
`;

export const PlainInput = styled.input`
  width: 100%;
  height: 2.8rem;
  border: 0.5px solid ${surface.line};
  border-radius: 0.56rem;
  padding: 0 0.8rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(1)};
  color: ${ink};
  background: #fff;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: ${brand.orange};
  }

  &::placeholder {
    color: #aaa;
  }
`;

export const ModalidadeContainer = styled.div`
  min-width: 180px;
`;

export const FormButtonsRow = styled.div`
  display: flex;
  justify-content: flex-end;

  margin-top: 1.5rem;

  .secondary-button,
  .primary-button {
    height: 2.8rem;
    border-radius: 0.55rem;
    font-family: 'RedHatDisplay-Bold';
    font-size: ${textSize(0.9)};
    padding: 0 1.6rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .secondary-button {
    border: 1px solid ${surface.line};

    &:hover {
      border: 1px solid ${brand.green};
      svg {
        transition: transform 0.3s;
        stroke: ${brand.green};
      }
    }
  }
`;
